const MAX_RETRIES = 5;  // Stop retrying after 5 attempts

export const listenToServerEvents = (userId, onMessageReceived, retryCount = 0) => {
  if (retryCount >= MAX_RETRIES) {
    console.log("Max retries reached. Stopping SSE reconnection.");
    return; // Stop retrying
  }

  let url = process.env.REACT_APP_CLARITY_BACKEND_BUILD_URL;
  let eventSource = new EventSource(`${url}/event/${userId}`, { withCredentials: true });

  eventSource.addEventListener("genai", (event) => {
    try {
      const data = JSON.parse(event.data);
      onMessageReceived(data);

      if (data?.result?.isGenAiResponseReceived) {
        console.log("SSE event closed because response received", data);
        eventSource.close(); // Close connection when response is received
      }
    } catch (error) {
      console.error("Error parsing SSE message", error);
    }
  });

  eventSource.onerror = (error) => {
    console.error("SSE connection error:", error);
    eventSource.close();

    // Retry connection with exponential backoff
    const retryDelay = Math.min(5000 * Math.pow(2, retryCount), 60000); // Max delay 60s
    console.log(`Reconnecting in ${retryDelay / 1000} seconds... (Attempt ${retryCount + 1}/${MAX_RETRIES})`);

    setTimeout(() => {
      listenToServerEvents(userId, onMessageReceived, retryCount + 1);
    }, retryDelay);
  };

  eventSource.onclose = () => {
    console.log("SSE connection closed manually.");
  };

  return () => {
    eventSource.close();
  };
};
